import { render, staticRenderFns } from "./placeholders.vue?vue&type=template&id=ed5bc732&scoped=true&"
import script from "./placeholders.vue?vue&type=script&lang=js&"
export * from "./placeholders.vue?vue&type=script&lang=js&"
import style0 from "./placeholders.vue?vue&type=style&index=0&id=ed5bc732&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5bc732",
  null
  
)

export default component.exports